import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.json.parse.js";
export default {
  name: "compXinjiang",
  props: {
    /** 地区弹窗显隐，由父组件统一持有，避免与分类显隐不同步 */
    regionModalVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ["typeselect", "update:regionModalVisible", "region-modal-change"],
  data() {
    return {
      typeIndex: 0,
      typebtn: [],
      alltitle: "全部",
      allRegionLabel: "新疆全区",
      typeclick: false,
      ulchildSstyle: {},
      ulchildClass: "",
      ctypeArr: [],
      fid: "",
      isUseComp1: true,
      childIndex: "",
      isHovered: {},
      currentRegionLabel: "新疆全区",
      isMobileView: false,
      regionDrag: {
        active: false,
        startX: 0,
        startScrollLeft: 0,
        moved: false
      }
    };
  },
  computed: {
    isXinjiangMap() {
      return this.fid === "46066";
    },
    computedProp() {
      return [this.$attrs.typebtnstyle, this.$attrs.posstyle];
    },
    barStyle() {
      const pos = this.$attrs.posstyle || {};
      return {
        position: "absolute",
        zIndex: 6,
        ...pos
      };
    },
    modalVisible: {
      get() {
        return this.regionModalVisible;
      },
      set(val) {
        const next = !!val;
        this.$emit("update:regionModalVisible", next);
        this.$emit("region-modal-change", next);
      }
    }
  },
  watch: {
    "$attrs.typelist": {
      handler(val) {
        this.ctypeArr = val.length > 0 ? val.map(() => {
          return "";
        }) : [];
      },
      deep: true
    },
    "$attrs.showtypeall": {
      handler(val) {
        if (this.typeclick) return;
        this.typeIndex = val ? 0 : 1;
      },
      deep: true
    },
    computedProp() {
      this.typebtn = [...this.$attrs.typebtnstyle];
      this.getChildulStyle(this.$attrs.posstyle);
    }
  },
  mounted() {
    this.fid = this.$route.query.fid;
    if (this.fid === "253618") this.isUseComp1 = false;
    if (this.fid === "46066") {
      this.allRegionLabel = "新疆全区";
      this.currentRegionLabel = "新疆全区";
    }
    this.isMobileView = window.innerWidth <= 768;
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    this.removeRegionDragListeners();
  },
  methods: {
    openRegionModal() {
      this.modalVisible = true;
    },
    closeRegionModal() {
      this.modalVisible = false;
    },
    typeClick(item, index) {
      this.typeclick = true;
      this.typeIndex = index;
      this.childIndex = "";
      this.ctypeArr = this.ctypeArr.map(() => "");
      if (index === 0) this.currentRegionLabel = this.allRegionLabel;else if (item?.itemformdata?.title) this.currentRegionLabel = item.itemformdata.title;
      this.$emit("typeselect", {
        index,
        item
      });
    },
    selectRegion(item, index) {
      this.closeRegionModal();
      this.typeClick(item, index);
    },
    handleResize() {
      this.isMobileView = window.innerWidth <= 768;
      // 切到非移动布局时强制关弹窗，避免父级仍认为弹窗打开从而藏掉分类
      if (!this.isMobileView && this.modalVisible) this.closeRegionModal();
    },
    scrollRegionBar() {
      const el = this.$refs.regionScroll;
      if (el) el.scrollBy({
        left: 280,
        behavior: "smooth"
      });
    },
    getRegionScrollEl() {
      return this.$refs.regionScroll;
    },
    removeRegionDragListeners() {
      document.removeEventListener("mousemove", this.onRegionDragMove);
      document.removeEventListener("mouseup", this.onRegionDragEnd);
    },
    onRegionDragStart(e) {
      if (e.button !== 0) return;
      const el = this.getRegionScrollEl();
      if (!el) return;
      this.regionDrag = {
        active: true,
        startX: e.pageX,
        startScrollLeft: el.scrollLeft,
        moved: false
      };
      el.style.scrollBehavior = "auto";
      document.addEventListener("mousemove", this.onRegionDragMove);
      document.addEventListener("mouseup", this.onRegionDragEnd);
    },
    onRegionDragMove(e) {
      if (!this.regionDrag.active) return;
      const el = this.getRegionScrollEl();
      if (!el) return;
      const dx = e.pageX - this.regionDrag.startX;
      if (Math.abs(dx) > 3) this.regionDrag.moved = true;
      el.scrollLeft = this.regionDrag.startScrollLeft - dx;
    },
    onRegionDragEnd() {
      if (!this.regionDrag.active) return;
      this.removeRegionDragListeners();
      const el = this.getRegionScrollEl();
      if (el) el.style.scrollBehavior = "";
      this.regionDrag.active = false;
      if (this.regionDrag.moved) {
        setTimeout(() => {
          this.regionDrag.moved = false;
        }, 0);
      }
    },
    onRegionTouchStart(e) {
      if (!e.touches.length) return;
      const el = this.getRegionScrollEl();
      if (!el) return;
      this.regionDrag = {
        active: true,
        startX: e.touches[0].pageX,
        startScrollLeft: el.scrollLeft,
        moved: false
      };
      el.style.scrollBehavior = "auto";
    },
    onRegionTouchMove(e) {
      if (!this.regionDrag.active || !e.touches.length) return;
      const el = this.getRegionScrollEl();
      if (!el) return;
      const dx = e.touches[0].pageX - this.regionDrag.startX;
      if (Math.abs(dx) > 3) this.regionDrag.moved = true;
      el.scrollLeft = this.regionDrag.startScrollLeft - dx;
    },
    onRegionTouchEnd() {
      if (!this.regionDrag.active) return;
      const el = this.getRegionScrollEl();
      if (el) el.style.scrollBehavior = "";
      this.regionDrag.active = false;
      if (this.regionDrag.moved) {
        setTimeout(() => {
          this.regionDrag.moved = false;
        }, 0);
      }
    },
    onRegionWheel(e) {
      const el = this.getRegionScrollEl();
      if (!el) return;
      const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      if (delta === 0) return;
      el.scrollLeft += delta;
      e.preventDefault();
    },
    handleRegionPillClick(item, index) {
      // 拖动滚动条时抑制误点；单击（位移小于阈值）仍需切换
      if (this.regionDrag.moved) {
        this.regionDrag.moved = false;
        return;
      }
      this.typeClick(item, index);
    },
    childtypeClick(item, index, child, cIndex) {
      this.typeIndex = index;
      this.childIndex = cIndex;
      this.ctypeArr = this.ctypeArr.map(() => "");
      this.ctypeArr[index - 1] = cIndex;
      this.$emit("typeselect", {
        index,
        item,
        child,
        cIndex
      });
    },
    getChildren(item, type) {
      const json = item?.itemformdata?.json;
      if (!json) return type === 0 ? false : [];
      try {
        const nextLevel = [...JSON.parse(String(json).replace(/(<\/?p.*?>)/gi, ""))];
        return type === 0 ? nextLevel.length > 0 : nextLevel;
      } catch (e) {
        return type === 0 ? false : [];
      }
    },
    getChildulStyle(val) {
      const margin = this.typebtn.length > 0 && this.typebtn[0].margin !== undefined ? Number(this.typebtn[0].margin.replace("vw", "")) : 0;
      let style = {};
      if (val.display && val.display === "flex") {
        style.left = "-50%";
        if (val.top) style.top = "100%";
        if (val.bottom) style.bottom = "100%";
        this.ulchildClass = "";
      } else if (!val.display || val.display && val.display === "block") {
        if (val.left) style.left = "100%";
        if (val.right) style.right = `100%`;
        style.width = `calc(100% + ${margin * 2}vw)`;
        this.ulchildClass = "normal";
      }
      this.ulchildSstyle = style;
    },
    setHover(isHover, index) {
      this.isHovered = {
        ...this.isHovered,
        [index]: isHover
      };
    }
  }
};